/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Checkbox, Row, Col } from "antd";

export function FormCheckboxGroup({
  id,
  name,
  label,
  required,
  options,
  layout, // 'vertical' | 'horizontal'
  defaultValue,
  ...rest
}: any) {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={[
        {
          required: required,
          message: `Please select ${label.toLowerCase()}!`,
        },
      ]}
    >
      <Checkbox.Group {...rest} defaultValue={defaultValue}>
        <Row>
          {options?.map((option: any, index: number) => (
            <Col
              span={layout === "vertical" ? 24 : 8}
              key={option.value}
              className="mb-2"
            >
              <Checkbox value={option.value}>{option.label}</Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </Form.Item>
  );
}